import { CountUp } from "countup.js";

export function setBackgroundElement () {
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		var backgroundMobile = $(this).attr("setbackgroundmobile");
		var backgroundResult = window.matchMedia('(min-width: 1024px)').matches ? background : backgroundMobile;
		$(this).css({
			"background-image": "url(" + backgroundResult + ")",
			"background-size": "cover",
			"background-position": "center center",
		});
	});
}
export function detectCloseElement (ele, ele2, funcRemove) {
	// close
	$(document).on("click", function (e) {
		console.log();
		if (!$(e.target).closest(ele).length && !$(e.target).hasClass(ele2)) {
			funcRemove();
		}
	});
	// esc
	$(document).keyup(function (e) {
		if (e.key === "Escape") {
			funcRemove();
		}
	});
	// overlay-blur
}
export function buttonToTop () {
	let lastScrollTop = 0;
	const $btn = $(".button-to-top");

	$(window).on("scroll", function () {
		let scrollTop = $(this).scrollTop();

		if (scrollTop > 100) {
			$btn.addClass("active");
		} else {
			$btn.removeClass("active");
		}

		lastScrollTop = scrollTop;
	});

	// Click để cuộn lên đầu trang
	$(document).on("click", ".button-to-top", function () {
		$("html, body").animate({ scrollTop: 0 }, 400);
	});
}

export function ToggleItem () {
	const nodeParent = $(".wrap-item-toggle");
	const nodeItem = nodeParent.find(".item-toggle");
	const nodeTitle = nodeItem.find(".title");

	// 👉 Mở sẵn toggle đầu tiên
	const firstItem = nodeItem.first();
	firstItem.addClass("active");
	firstItem.find(".title").addClass("active");
	firstItem.find(".content").slideDown(0); // 0 để mở ngay không animation

	// 👉 Bắt sự kiện toggle khi click
	nodeTitle.on("click", function () {
		const $this = $(this);
		const $itemToggle = $this.closest(".item-toggle");
		const isActive = $this.hasClass("active");

		// Reset all
		nodeItem.removeClass("active");
		nodeTitle.removeClass("active").next().slideUp();

		if (!isActive) {
			$this.addClass("active").next().slideDown();
			$itemToggle.addClass("active");
		}
	});
}

/**
 * parent, children, item, button, initItem
 * @param { parent, children, item, button, initItem} listNode
 */
export function funcExpandContent (listNode) {
	const { parent, children, item, button, initItem, gap = 0 } = listNode;
	if (!$(parent).length) return;
	let itemHeight = $(item).outerHeight();
	let gapCalculate = gap
		? Number($(parent).find(children).css("column-gap").slice(0, -2)) * gap
		: 0;
	let initHeight = itemHeight * initItem + gapCalculate;
	let originalHeight = $(parent).find(children).outerHeight();
	if (originalHeight < initHeight) {
		$(button).remove();
	} else {
		$(parent).css("height", initHeight);
	}
	$(button).on("click", function () {
		if ($(this).hasClass("expand")) {
			$(parent).css("height", initHeight);
			$(this).find("span").text("Xem thêm");
		} else {
			$(parent).css("height", originalHeight);
			// setTimeout(() => {
			// 	$(parent).css("height", "auto");
			// }, 1000);
			$(this).find("span").text("Rút gọn");
		}
		$(this).toggleClass("expand");
	});
}

export function clickScrollToDiv (nodeEle, heightSpacing = () => { }) {
	$(nodeEle).on("click", function (event) {
		let height = 0;
		$(this).addClass("active").siblings().removeClass("active");
		if (heightSpacing) {
			height = heightSpacing();
		} else {
			height = 0;
		}
		if (this.hash !== "") {
			event.preventDefault();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - height,
				},
				800
			);
		}
	});
}

export function appendCaptchaASP () {
	if (!$("#ctl00_mainContent_ctl01_pnlFormWizard").length) return;
	// Select the div element you want to observe
	const myDiv = document.querySelector("#ctl00_mainContent_ctl01_pnlFormWizard");
	// Create a new MutationObserver object
	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			console.log("Run");
			appendCaptcha();
		});
	});
	// Configure the observer to listen for changes to the "class" attribute
	const config = { attributes: true, characterData: true, childList: true };
	// Start observing the target div element
	observer.observe(myDiv, config);
	function appendCaptcha () {
		$(".form-group.frm-captcha").appendTo(".wrap-form-submit");
		$(".form-group.frm-btnwrap").appendTo(".wrap-form-submit");
	}
	appendCaptcha();
}
export function replaceSvgImages () {
	$(".img-svg").each(function () {
		const $img = $(this);
		const imgURL = $img.attr("src");
		const imgClass = $img.attr("class");
		const imgWidth = $img.attr("width");
		const imgHeight = $img.attr("height");

		$.ajax({
			url: imgURL,
			dataType: "text",
			success: function (svgContent) {
				// Create a new div to hold the SVG content
				const $svgDiv = $("<div>").html(svgContent);
				const $svg = $svgDiv.find("svg");

				// Apply original image attributes to SVG
				if (imgClass) {
					$svg.addClass(imgClass);
				}

				// Replace the image with the SVG
				$img.replaceWith($svg);
			},
			error: function (error) {
				console.error("Error fetching SVG:", error);
			},
		});
	});
}
export function indicatorSlide () {
	if ($(".indicator-swipe").length > 0) {
		var callback = function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add("active");
					setTimeout(function () {
						entry.target.classList.remove("active");
					}, 3000);
				}
			});
		};

		var observer = new IntersectionObserver(callback);
		var animationItems = document.querySelectorAll(".indicator-swipe");
		animationItems.forEach(function (item) {
			observer.observe(item);
		});
	}
}

export function countUpInit () {
	const countUpElements = document.querySelectorAll(".countup");

	countUpElements.forEach((element) => {
		const targetNumber = element.getAttribute("data-number");
		const suffix = element.getAttribute("data-suffix") || "";
		const countValueEl = element.querySelector(".count-value");

		if (!countValueEl) return;

		const countUp = new CountUp(countValueEl, targetNumber, {
			duration: 4,
			separator: ".",
			decimal: ",",
			suffix: suffix,
			enableScrollSpy: true,
			scrollSpyOnce: true,
		});

		if (!countUp.error) {
			countUp.start();
		} else {
			console.error(countUp.error);
		}
	});
}


export function draggableScroll ({
	parent,
}) {
	if (!$(parent).length) return;
	let isPointerDown = false;
	let startX, scrollLeft;
	let hasMoved = false;
	let startTime;
	let lastX, lastTime;
	let velocityX = 0;
	let momentumId = null;
	const slider = document.querySelector(parent);

	const startDragging = (e) => {
		// Cancel any ongoing momentum
		if (momentumId) {
			cancelAnimationFrame(momentumId);
			momentumId = null;
		}

		isPointerDown = true;
		hasMoved = false;
		startTime = Date.now();
		lastTime = startTime;
		startX = e.pageX - slider.offsetLeft;
		lastX = startX;
		scrollLeft = slider.scrollLeft;
		velocityX = 0;

		// Prevent text selection and default behaviors
		e.preventDefault();
		slider.style.cursor = 'grabbing';
		slider.style.userSelect = 'none';
	}

	const stopDragging = (e) => {
		if (!isPointerDown) return;

		isPointerDown = false;
		slider.style.cursor = '';
		slider.style.userSelect = '';

		// Apply momentum if we have velocity
		if (Math.abs(velocityX) > 0.5) {
			applyMomentum();
		}

		// If we moved, prevent click on any links
		if (hasMoved) {
			// Small delay to ensure click event is captured
			setTimeout(() => {
				hasMoved = false;
			}, 10);
		}
	}

	const move = (e) => {
		if (!isPointerDown) return;

		const x = e.pageX - slider.offsetLeft;
		const scroll = x - startX;
		const currentTime = Date.now();

		// Calculate velocity for momentum
		const deltaTime = currentTime - lastTime;
		if (deltaTime > 0) {
			const deltaX = x - lastX;
			velocityX = deltaX / deltaTime * 16; // Normalize to 60fps
		}

		lastX = x;
		lastTime = currentTime;

		// Mark as moved on any movement
		if (Math.abs(scroll) > 1) {
			hasMoved = true;
		}

		// Always update scroll position when moving
		slider.scrollLeft = scrollLeft - scroll;
	}

	const applyMomentum = () => {
		const friction = 0.95; // Momentum decay factor
		const minVelocity = 0.1; // Stop when velocity is too small

		if (Math.abs(velocityX) < minVelocity) {
			momentumId = null;
			return;
		}

		// Apply velocity to scroll position
		slider.scrollLeft -= velocityX;

		// Decay velocity
		velocityX *= friction;

		// Continue momentum
		momentumId = requestAnimationFrame(applyMomentum);
	}

	// Prevent clicks when we've been dragging
	const preventClick = (e) => {
		if (hasMoved) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			return false;
		}
	}

	// Add the event listeners
	slider.addEventListener('mousedown', startDragging, false);
	slider.addEventListener('mousemove', move, false);
	slider.addEventListener('mouseup', stopDragging, false);
	slider.addEventListener('mouseleave', stopDragging, false);

	// Prevent clicks when dragging (capture phase to catch early)
	slider.addEventListener('click', preventClick, true);

	// Also handle touch events for mobile
	slider.addEventListener('touchstart', (e) => {
		const touch = e.touches[0];
		startDragging({
			pageX: touch.pageX,
			preventDefault: () => e.preventDefault()
		});
	}, false);

	slider.addEventListener('touchmove', (e) => {
		const touch = e.touches[0];
		move({
			pageX: touch.pageX
		});
		e.preventDefault(); // Prevent scrolling
	}, false);

	slider.addEventListener('touchend', (e) => {
		stopDragging(e);
	}, false);

	// Stop momentum when user touches again
	slider.addEventListener('mousedown', (e) => {
		if (momentumId) {
			cancelAnimationFrame(momentumId);
			momentumId = null;
		}
	}, true);

	slider.addEventListener('touchstart', (e) => {
		if (momentumId) {
			cancelAnimationFrame(momentumId);
			momentumId = null;
		}
	}, true);
}